import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@aws-amplify/ui-react';
import { Logger, Auth } from 'aws-amplify';
import { confirmAlert } from 'react-confirm-alert';
import { Message } from '../utils';
import { s3ListObjects, s3DeleteFile } from '../s3Utils';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

var AWS = require('aws-sdk');

const logger = new Logger('JRemoveAccount');


const JRemoveAccount = (props) => {
  const [error, setError] = useState('');
  const timerRef = useRef(null);

  const removeAccount = () => {
    removeAllFiles() // first remove all private files
    // console.log(props.user.attributes["custom:kvsID"]  !== '4102019')
    if (props.user.attributes["custom:kvsID"] !== '4102019') {
      let region = props.user.pool.userPoolId.split("_")[0];
      var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
        "region": region
      });
      var params = {
        AccessToken: props.user.signInUserSession.accessToken.jwtToken
      };
      cognitoidentityserviceprovider.deleteUser(params, function (err, data) {
        if (err) {
          setError(err);
          timerRef.current = setTimeout(() => setError(''), 5000);
        } else {
          // remove data
          Auth.signOut();

          logger.info('removeAccount reached ', region);
        }
      });
    } else {
      setError('Der Testuser kann nicht gelöscht werden, aber alle Daten sind jetzt gelöscht.');
    }
  };

  const deleteS3ListFiles = (result) => {
    const keys = Object.keys(result);
    keys.forEach(element => {
      s3DeleteFile(element)
    });
  }

  const removeAllFiles = () => {
    s3ListObjects('', 'private', deleteS3ListFiles);
  }

  const showConfirmAlert = () => {
    confirmAlert({
      title: 'Löschen bestätigen',
      message: 'Sind Sie sicher, dass Sie Ihre Zugangsdaten und alle weiteren Daten löschen wollen?',
      buttons: [
        {
          label: 'Ja, alles löschen',
          onClick: () => removeAccount()
        },
        {
          label: 'Nein',
        }
      ]
    });
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return (
    <>
      <Button
        variant="primary"
        mt="4"
        onClick={showConfirmAlert}>Registrierung mit allen Daten löschen!</Button>
      {error && <Message children={error} />}
    </>
  )
}

export default JRemoveAccount;